/**
 * Monta o deep link de WhatsApp para o paciente a partir do número verificado.
 *
 * **Não existia nada disso no repositório antes da Fase 4.** O único WhatsApp do
 * `cinco-front` era o `ButtonWhatsApp`, que aponta para um número de **suporte**
 * hard-coded — não para o paciente. A ação de contato da home de Alertas é a
 * primeira que fala com o titular.
 *
 * O back devolve o número em **E.164** (`+55DDDNNNNNNNNN`), produzido pelo
 * `normalizeWhatsappToE164`. O `wa.me` quer só dígitos, então o `+` sai — e mais
 * nada: retirar outros caracteres aqui mascararia um número mal normalizado do outro
 * lado, que é defeito a corrigir na origem e não a contornar na tela.
 *
 * ⚠️ **Devolve `null` quando não há vínculo ativo**, e quem chama tem de desabilitar
 * o botão com explicação em vez de abrir um link quebrado. Um `wa.me` sem número
 * abre a lista de contatos do usuário, que é pior do que não abrir nada: a
 * enfermeira acharia que a ação funcionou.
 */
export default function getWhatsappLink(
  whatsapp: string | null,
  hasActiveWhatsapp: boolean,
): string | null {
  if (!hasActiveWhatsapp || !whatsapp) {
    return null;
  }

  const digits = whatsapp.replace(/^\+/, '');

  if (!digits) {
    return null;
  }

  return `https://wa.me/${digits}`;
}
